import React from "react"
import { useTranslation } from "react-i18next";
import "@/app/pages/pageNotFound/PageNotFound.scss"
import { Helmet } from "react-helmet";
import { messageCenterAlignRegions, linksLeftAlignRegions } from "./constants";

const PageNotFound = ({ countryCode }) => {
  const { t } = useTranslation();

  const suggestionLink = `<a
    href=${t("bdLandingPageRedirectionLink")}
    style="text-decoration: none; color:#0d7594"
  >
    ${t("noPage.searching")}
  </a>`;

  interface SuggestedLink {
    label: string;
    url: string;
  }

  const suggestionHtml = t("noPage.suggestionText").replace("${linkText}", suggestionLink)

  const rawSuggestedLinks = t("noPage.suggestedLinks", { returnObjects: true });

  const isSuggestedLinkArray = (obj: any): obj is SuggestedLink[] => {
    return Array.isArray(obj) && obj.every(item => 'label' in item && 'url' in item);
  };

  const suggestedLinks: SuggestedLink[] = isSuggestedLinkArray(rawSuggestedLinks) ? rawSuggestedLinks : [];

  return (
    <>
    <Helmet>
      <title>404</title>
    </Helmet>
    <div className="content" role="main">
      <div className="content-par parsys">
        <div className="basecomp RootBaseComponent section">
          <div className="component-wrapper">
            <div className="container">
              <div className="row px-2">
                <div className="col-md-12">
                  <div className="colPar0 parsys">
                    <div className="content_head basecomp RootBaseComponent section">
                      <div className="contentHeadWrapper">
                        <div className="component-wrapper ">
                          <div className="row error-text-container">
                            <div className="col-md-12 col-xs-12 clearfix" style={{ paddingTop: 0}}>
                              <p className="error-message"></p>
                              <h1 className="title" style={{textAlign: messageCenterAlignRegions.includes(countryCode) ? 'center' : 'unset'}}>
                                {t("noPage.title") || "Oh no! 404 Error"}
                              </h1>
                              <p className="subtitle" style={{textAlign: messageCenterAlignRegions.includes(countryCode) ? 'center' : 'unset'}}>
                                {t("noPage.subtitle") || "Looks like this page no longer exists."}
                              </p>
                            </div>
                          </div>

                        {countryCode !== "pl" && (
                          <div className="row">
                            <div className="col-md-12">
                              <p className="subtitle font24">
                                <span dangerouslySetInnerHTML={{ __html: suggestionHtml }} />
                                {/* Try <a className="anchor" href="#">searching</a> or browse some of our recent Perspectives. */}
                              </p>
                            </div>
                          </div>
                        )}

                        {["de", "at", "ch", "hu"].includes(countryCode) && (
                          <div className="row">
                            <div className="col-md-12">
                              <div className="content_text RootBaseComponent section">
                                <hr />
                                  <div className="contenttext">
                                    <ul>
                                    {suggestedLinks && suggestedLinks?.map(({ label, url }) => (
                                      <li style={{textAlign: linksLeftAlignRegions.includes(countryCode) ? 'unset': 'center'}}>
                                      <a className="anchor" href={url}>
                                        {label}
                                      </a>
                                    </li>
                                    ))}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                        )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="clear"></div>
          </div>
        </div>
        {/* <RelatedArticles /> */}
      </div>
    </div>
  </>
  )
}

export default PageNotFound;
